import * as t from 'io-ts';

export const UuidSchema = t.string;

export type Uuid = string;
